import { use } from "react";
import {
  cambiarEstadoActa,
  cancelarActa,
  finalizarACta,
  getActa,
  getMisActas,
  getTiposSolicitudes,
  primeraEtapa,
  segundaEtapa,
  terceraEtapa,
} from "../services/actas.service";
import { useAdminStore } from "../store/adminStore";
import { useDataUserStore } from "../store/dataUserStore";
import { useFormActaStore } from "../store/formActaStore";
import { getActas } from "../services/admin.service";

const { setMisActas } = useDataUserStore.getState();
const { setDefaultValues, formActive, setFormActive, defaultValues, setTiposSolicitudes } =
  useFormActaStore.getState();
const { acta, setActa, setActas } = useAdminStore.getState();

export const handlerMisActas = async () => {
  const result = await getMisActas();
  if (result) setMisActas(result);
};

export const handlerGetActa = async (id) => {
  const result = await getActa(id);
  if (result) {
    setDefaultValues(result);
    setFormActive(true);
  }
};

export const primeraEtapaHandler = async (payload) => {
  const result = await primeraEtapa(payload);
  if (result) {
    setDefaultValues(result);
  }
};

export const segundaEtapaHandler = async (payload, id) => {
  const result = await segundaEtapa(payload, id);
  if (result) {
    setDefaultValues(result);
  }
};

export const terceraEtapaHandler = async (payload, id) => {
  const result = await terceraEtapa(payload, id);
  if (result) {
    setDefaultValues(result);
  }
};

export const handlerCancelar = async (payload) => {
  const result = await cancelarActa(payload);
  if (result) {
    let { acta } = useAdminStore.getState();
    let { defaultValues } = useFormActaStore.getState();
    if (acta) {
      setActa(result);
      const refreshActas = await getActas();
      if (refreshActas) {
        setActas(refreshActas);
      }
    }
    defaultValues && setDefaultValues(result);
  }
};

export const handlerCambiarEstado = async (payload) => {
  const result = await cambiarEstadoActa(payload);
  if (result) {
    let { acta } = useAdminStore.getState();
    let { defaultValues } = useFormActaStore.getState();
    if (acta) {
      setActa(result);
      const refreshActas = await getActas();
      if (refreshActas) {
        setActas(refreshActas);
      }
    }
    if (defaultValues) {
      setDefaultValues(result);
    }
  }
};

export const handlerFinalizarActa = async (payload) => {
  const result = await finalizarACta(payload);
  if (result) {
    let { defaultValues } = useFormActaStore.getState();
    defaultValues && setDefaultValues(result);
  }
};

export const getTiposSolicitudesHandler = async () => {
  const result = await getTiposSolicitudes();
  if (result) {
    setTiposSolicitudes(result);
  }
};
